<script>
export default {
    props: {
        item: { type: Object, default () {} }
    }
}
</script>
<template>
    <span>
        <span v-for="i in item.record" :key="i.key">
            <i style="opacity:0.5">{{ i.key }} :</i> <span>{{ i.value }}</span> <br/>
        </span>
        <!-- issue 659 -->
        <span v-if="item.request && item.request.status">
            <i style="opacity:0.5">Status :</i> <span>{{item.request.status}}</span> <br/>
        </span>
        <!-- issue 659 -->
    </span>
</template>